<template>
  <el-form @submit.native.prevent="creatBanner" :inline="true">
    <div>
      <el-form-item label="选择网校">
        <el-select v-model="model.maID" placeholder="网校">
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          multiple
          v-model="model.chID"
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          multiple
          v-model="model.coID"
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item multiple label="三级分类">
        <el-select
          v-model="choosedList"
          multiple
          placeholder="三级分类"
          @change="selectChange"
        >
          <div style="padding: 0 20px; line-height: 34px">
            <el-checkbox
              v-model="chooseAll"
              :indeterminate="indeterminate"
              @change="chooseAll_change"
            >
              全选
            </el-checkbox>
          </div>
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-card style="margin-top: 25px">
        <el-form-item label="banner标题">
          <el-input v-model="model.bannerName"></el-input>
        </el-form-item>
        <el-form-item label="banner描述">
          <el-input v-model="model.bannerDesc"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input v-model="model.bannerUrl"></el-input>
        </el-form-item>
        <el-form-item label="bannerID(自动生成)">
          <el-input
            :disabled="true"
            v-model="bannerID"
            @input="bannerID"
          ></el-input>
        </el-form-item>
        <!-- 上传bammer图 -->
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/news/img/banner'"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          list-type="picture"
          :on-success="bannerUpload"
        >
          <div>
            <img v-show="showLeImg" :src="model.bannerImg" />
          </div>
          <el-button size="small" type="primary"
            >点击上传newsBanner图</el-button
          >
        </el-upload>
      </el-card>
    </div>

    <el-form-item style="margin-top: 25px">
      <el-button type="primary" native-type="submit">点击创建</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    id: {},
  },
  data() {
    return {
      showCoImg: true,
      showLeImg: true,
      major: [],
      bannerID: "",
      channel: [],
      course: [],
      shclass: [],
      choosedList: [],
      indeterminate: false,
      chooseAll: false,
      model: {
        bannerImg: "",
      },
      banner: [],
      bannerCate: [],
    };
  },
  methods: {
    async creatBanner() {
      try {
        const params = {
          maID: this.model.maID,
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.choosedList,
          bannerName: this.model.bannerName,
          bannerUrl: this.model.bannerUrl,
          bannerDesc: this.model.bannerDesc,
          bannerImg: this.model.bannerImg,
          bannerID: this.bannerID,
        };
        const bannnercreate = await this.$http.post(
          "/news/banner/create",
          params
        );
        if (bannnercreate.status === 200) {
          this.$message({
            type: "success",
            message: bannnercreate.data.msg,
          });
        }
        this.$router.push("/newsbanner/list");
      } catch (error) {
        console.log(error);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel(item) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }

      //this.getlesson(item);
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.shclass = getclass.data;
      } catch (error) {
        console.log(error);
      }
    },
    selectChange(newSelect) {
      if (newSelect.length === this.shclass.length) {
        this.chooseAll = true;
      } else {
        this.chooseAll = false;
      }
    },
    chooseAll_change() {
      if (this.choosedList.length < this.shclass.length) {
        this.choosedList = this.shclass.map((item) => {
          return item.clID;
        });
        this.chooseAll = true;
      } else {
        this.choosedList = [];
        this.chooseAll = false;
      }
    },

    async getBannerCate() {
      try {
        const result = await this.$http.get("/bannercate/getbannercate");
        this.bannerCate = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    bannerUpload(res) {
      try {
        this.model.bannerImg = res.location;
        this.showLeImg = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePreview(file) {
      console.log(file);
    },

    handleRemove(uploadFile, uploadFiles) {
      console.log(uploadFile, uploadFiles);
    },
    //生成目录名称conID
    createBannerID() {
      this.bannerID = Date.now();
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.createBannerID();
  },
};
</script>

<style scoped></style>
